<script>
	import Icon from './General/Icon.svelte';
	import InfoGrid from './InfoGrid.svelte';
	import Divider from './General/Divider.svelte';
	import Container from './Container.svelte';
	import { translate } from '../lib/translate';

	export let data;
</script>

<main>
	<Container>
		{#if data}
			<h2>{translate('general_specifications')}</h2>
			{#each data.specification as spec, i}
				<h3>{translate(spec.key)}</h3>
				{#if spec.key === 'features'}
					<div class="feature-list">
						{#each spec.value as item}
							{#if item.key === 'subTitle'}
								<h4>{translate(item.value)}</h4>
							{:else}
								<div class="feature-item">
									{#if item.value === 'yes_tick'}
										<div class="icon">
											<Icon name="CHECKMARK" size={14} cssFill="--c-sky-blue" />
										</div>
									{:else}
										{translate('no')}
									{/if}
									{translate(item.key)}
								</div>
							{/if}
						{/each}
					</div>
				{:else if spec.key === 'axles_and_tires'}
					<InfoGrid
						ratio={[1, 4]}
						columns={[1]}
						cells={spec.value.map(item => [translate(item.key), translate(item.value)])}
					/>
					{#each data.axles as axle, i}
						<div class="axle">
							<h4>Achse {i+1}</h4>
							<div>
								<InfoGrid
									ratio={[1, 4]}
									columns={[1]}
									cells={Object.entries(axle).filter(([key]) => !['_nr', 'tyre', 'axleCount', 'label', 'max_axle_weight'].includes(key)).map(([key, value]) => [translate(key), translate(value)])}
								/>
							</div>
						</div>
					{/each}
				{:else if spec.key === 'other'}
					<InfoGrid
						width="500px"
						ratio={[2, 3]}
						columns={[1]}
						cells={spec.value.map(item => [translate(item.key), translate(item.value)])}
					/>
				{:else}
					<InfoGrid
						ratio={[2, 3]}
						columns={[1, 2, 3]}
						cells={spec.value.map(item => [translate(item.key), translate(item.value)])}
					/>
				{/if}
				{#if i !== data.specification.length-1}
					<Divider />
				{/if}
			{/each}
		{/if}
	</Container>
</main>


<style lang="scss">
	main {
		display: block;
		padding: 80px 0;

		h2 {
			font-size: 32px;
			font-weight: 700;
			line-height: 33px;
			color: var(--c-primary);
			margin-bottom: 31px;
		}

		h3 {
			font-size: 24px;
			font-weight: 600;
			line-height: 24px;
			color: var(--c-primary);
			margin-bottom: 20px;
			&:not(:first-child) {
				margin-top: 45px;
			}
		}

		.axle {
			&:not(:first-child) h4 {
				margin-top: 38px;
			}
		}

		h4 {
			font-size: 20px;
			font-weight: 600;
			line-height: 30px;
			color: var(--c-primary);
			margin-bottom: 10px;
		}
	}

	.feature-list {
		width: 1041px;
		display: flex;
		flex-wrap: wrap;

		@media (max-width: 899px) {
			width: 100%;
		}

		h4 {
			width: 100%;
			&:not(:first-child) {
				margin-top: 45px;
			}
			&::first-letter {
				text-transform: uppercase;
			}
		}

		.feature-item {
			width: 25%;
			@media (max-width: 899px) {
				width: 50%;
			}
		}
	}

	.feature-item {
		color: black;
		font-size: 18px;
		line-height: 32px;
		display: flex;
		word-break: break-word;
		padding-right: 10px;
		&::first-letter {
			text-transform: uppercase;
		}

		.icon {
			display: inline-block;
			margin-right: 16px;
		}
	}
</style>
